export default "__VITE_ASSET__B2jyDk00__"